import { React } from 'external/react'
import { FAIcon, styled } from 'external/material'

type ResourceProps = {
  title: string
  href: string
  onDeleteClick: () => void
}

const StyledResource = styled('div')(resourceStyles)

const Resource = (props: ResourceProps) => {
  const { title, href, onDeleteClick} = props
  return (
    <StyledResource className="planrd-resource link">
      <div className="content">
        <div className="id">{title}</div>
        <a className="link" href={href} target="_blank" title={href}>
          <p className='link'>{href}</p>
        </a>
     </div>
     <div className="actions">
        <div className="delete" onClick={onDeleteClick}>
          <FAIcon icon="trash" />
        </div>
      </div>
    </StyledResource>
  )
}

function resourceStyles() {

  return {

    display: 'flex',
    justifyContent: 'flex-start',
    width: '100%',
    marginTop: 15,
    borderBottom: 'solid 1px #e2ecf2',
    '&:last-child': {
      borderBottom: 'none'
    },

    '& .content': {
      cursor: 'default',
      flexGrow: 1,
      color: '#4e576e',
      overflowX: 'hidden',
      overflowY: 'auto',
      padding: 0,
      minHeight: '40px',
      maxHeight: '150px',

      "& .id": {
        fontWeight: 'bold'
      },
      "& .link": {
            display: '-webkit-box',
            WebkitLineClamp: 3,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
      },
    },

    '& .actions': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      paddingLeft: '10px',
      '& .delete': {
        cursor: 'pointer',
        color: '#dd3636',
        backgroundColor: '#ededed',
        borderRadius: '50%',
        padding: '8px 9px',
        '&:hover': {
          transform: 'scale(1.10)'
        }
      }
      
    },
  }
}
export {Resource as default}
